import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { loginRoutes, LoginStackParamList } from "./types";
import { LoginProvider, TLoginContext } from "../contexts/LoginContext";
import PhoneCountryScreen, {
  phoneCountryScreenOptions,
} from "../screens/PhoneCountryScreen";
import PhoneScreen, { phoneScreenOptions } from "../screens/PhoneScreen";
import VerificationScreen, {
  verificationScreenOptions,
} from "../screens/VerificationScreen";

const Stack = createNativeStackNavigator<LoginStackParamList>();

export default function LoginNavigator(props: TLoginContext) {
  const { phone, country, code } = loginRoutes;

  return (
    <LoginProvider {...props}>
      <Stack.Navigator initialRouteName={phone}>
        <Stack.Screen
          name={phone}
          component={PhoneScreen}
          options={phoneScreenOptions}
        />
        <Stack.Screen
          name={country}
          component={PhoneCountryScreen}
          options={phoneCountryScreenOptions}
        />
        <Stack.Screen
          name={code}
          component={VerificationScreen}
          options={verificationScreenOptions}
        />
      </Stack.Navigator>
    </LoginProvider>
  );
}
